module.exports = __webpack_public_path__ + "img/press-bg-6.6cf59806.svg";